import { LucideIcon, Moon, Sun, Sunrise, Sunset } from "lucide-react";

export enum DayTime {
  Morning = "Morning",
  Midday = "Midday",
  Afternoon = "Afternoon",
  Evening = "Evening",
  Night = "Night",
}

export const DAY_TIME_ICON: Record<DayTime, LucideIcon> = {
  [DayTime.Morning]: Sunrise,
  [DayTime.Midday]: Sun,
  [DayTime.Afternoon]: Sun,
  [DayTime.Evening]: Sunset,
  [DayTime.Night]: Moon,
};

export const getDayTime = (date: Date): DayTime => {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) return DayTime.Morning;
  if (hour >= 12 && hour < 14) return DayTime.Midday;
  if (hour >= 14 && hour < 17) return DayTime.Afternoon;
  if (hour >= 17 && hour < 23) return DayTime.Evening;
  return DayTime.Night;
};
